import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { Renderer_DataField_Value } from '../../../../Renderer_DataFieldV2/Renderer_DataField_Value.js';
export const AdvisorWizardTree_AttributeRenderer = (props) => {
    const attribute = ModuleFE_Advisor_Variable.cache.unique(props.item.id);
    if (!attribute)
        throw new MUSTNeverHappenException(`Could not find a variable for _id ${props.item.id}`);
    const editable = props.item.editable;
    return _jsx(Renderer_DataField_Value, { disabled: props.item.disabled, variableId: attribute._id, selectedValueId: editable.item[0], onValueSelected: valueId => {
            if (!valueId)
                editable.delete();
            else
                editable.updateArrayAt(valueId, 0);
        } });
};
//# sourceMappingURL=attribute-renderer.js.map